/**
 * Created by mly on 2018/4/19.
 */
import UserFlowBase from '../../components/flow/user_flow_base.vue';
import {mapGetters} from "vuex";
export default {
    components: { UserFlowBase },
    props: {
        type: {
            type: String
        },
        banks: {
            type: Array
        },
        banks_hash: {
            type: Object
        }
    },
    data () {
        return {
            params: {
                search: ''
            },
            companies: [],
            companies_hash: {},
            active_tab: 'export',
            loading: false,
            expense_group_columns: [
                {
                    title: '编号',
                    key: 'uid',
                    width: 170,
                    render: (h, params) => {
                        let row = params.row;
                        let ret = [];
                        ret.push(h('div', {
                            'class': {
                                'color-error': row.del
                            }
                        }, row.uid));
                        if(row.del){
                            ret.push(h('div', {
                                'class': {
                                    'color-error': true
                                }
                            }, '已废弃'));
                        }
                        return h('div', ret);
                    }
                },
                {
                    title: '名称',
                    key: 'name'
                },
                {
                    title: '公司-团队',
                    render: (h, params) => {
                        let company = '未设置';
                        if(this.companies_hash[params.row.company_id]){
                            company = this.companies_hash[params.row.company_id].short_name;
                        }
                        let team = '未设置';
                        if(this.teams_hash[params.row.team_id]){
                            team = this.teams_hash[params.row.team_id].name;
                        }
                        let ret = [];
                        ret.push(h('div', {
                            'class':{
                                'text-bold': true
                            },
                        }, company));
                        ret.push(h('div', team));
                        return h('div', ret);
                    }
                },
                {
                    title: '申请人',
                    width: 60,
                    key: 'apply_user',
                    render: (h, params) => {
                        let row = params.row;
                        let ret = [];
                        ret.push(h('div', row.apply_user));
                        if(!row.is_formal_apply_customer){
                            ret.push(h('div', '非正式'));
                        }
                        return h('div', {
                            'class': {
                                'color-error': !row.is_formal_apply_customer
                            }
                        }, ret);
                    }
                },
                {
                    title: '付款对象',
                    render: (h, params) => {
                        let ret = params.row.payee_user || params.row.payee_company;
                        return h('div', ret);
                    }
                },
                {
                    title: '付款总金额',
                    align: 'right',
                    width: 100,
                    key: 'total_price',
                    render: (h, params) => {
                        let ret = [];
                        ret.push( h('Icon', {
                            props: {
                                type: 'logo-yen'
                            }
                        }) );
                        ret.push( h('span', ' ' + math.eval(params.row.total_price).toFixed(2) + ' ') );
                        return h('div',{
                            'class': {
                                'text-right': true
                            }
                        }, ret);
                    }
                },
                {
                    title: '状态',
                    width: 125,
                    key: 'status',
                    render: (h, params) => {
                        let row = params.row;
                        let user_flow = row.user_flow;
                        if(user_flow){
                            return h(UserFlowBase, {
                                props: {
                                    user_flow: user_flow,
                                    model: row,
                                    title: row.name
                                }
                            })
                        }
                        let ret = [];
                        if(row.del){
                            ret.push(h('div', {
                                'class': {
                                    'color-error': true
                                }
                            }, '已废弃'));
                            return h('div', ret);
                        }
                        ret.push(h('div', [
                            h('span', {}, '填写: '),
                            h('span', {}, row.fill_user),
                            h('span', {
                                'class': {
                                    'color-grey': true
                                }
                            }, ' ' + moment(row.created_at).format('YYYY-MM-DD')),
                        ]));
                        if(row.status === 0){
                            ret.push(h('span', {
                                'class': {
                                    'color-info': true
                                }
                            }, '待财务审核 '));
                        }
                        if(row.status === 5){
                            ret.push(h('div', [
                                h('span', {}, '审核: '),
                                h('span', {}, row.verify_user),
                                h('span', {
                                    'class': {
                                        'color-grey': true
                                    }
                                }, ' ' + moment(row.verified_at).format('YYYY-MM-DD')),
                            ]));
                            ret.push(h('div', [
                                h('span', {
                                    'class': {
                                        'color-info': true
                                    }
                                }, '待付款 '),
                            ]));
                        }
                        if(row.status === 9){
                            ret.push(h('div', [
                                h('span', {}, '审核: '),
                                h('span', {}, row.verify_user),
                                h('span', {
                                    'class': {
                                        'color-grey': true
                                    }
                                }, ' ' + moment(row.verified_at).format('YYYY-MM-DD')),
                            ]));
                            ret.push(h('div', [
                                h('span', {
                                    'class': {
                                        'color-success': true
                                    }
                                }, '完成: '),
                                h('span', {}, row.finish_user),
                                h('span', {
                                    'class': {
                                        'color-grey': true
                                    }
                                }, ' ' + moment(row.finished_at).format('YYYY-MM-DD')),
                            ]));
                        }
                        return h('div', ret);
                    }
                },
                {
                    title: '操作',
                    render: (h, params) => {
                        let ret = [];
                        ret.push( h('Button', {
                            props: {
                                type: 'warning',
                                size: 'small'
                            },
                            on: {
                                click: ()=>{
                                    this.removeExpenseGroup(params.row, params.index);
                                }
                            }
                        }, '删除') );
                        return h('div', ret);
                    }
                },
            ],
            set_bank_config: {
                modal: false,
                loading: true
            },
            export_params: {
                expense_payment_bank_id: 0,
                company: {}
            },
            batch_finish_expense_groups: [],
            batch_finish_params: {
                paid_at: '',
                expense_payment_bank_id: 0
            },
            logs: [],
            reloading: false,
            reload_expense_group_export_path: Util.api.reload_expense_group_export,
            log_config: {
                modal: true
            },
            have_expense_groups: false
        }
    },
    computed: {
        ...mapGetters({
            default_companies: 'async/companies',
            teams: 'async/root_teams',
            teams_hash: 'async/root_teams_hash',
        }),
    },
    watch:{
        default_companies(){
            this.genCompanies();
        }
    },
    created(){
        this.genCompanies();
    },
    mounted(){
        console.log(this.teams, this.companies, this.companies_hash);
    },
    methods: {
        genCompanies(){
            let companies = Util.clone(this.default_companies);
            this.companies = [];
            companies.forEach((c)=>{
                c.expense_groups = [];
                this.companies.push(c);
                this.companies_hash[c.id] = c;
            });
        },
        startQrScaner(){
            this.$Message.success('开始扫描!');
            eventHub.$emit('show-qr-scaner', (data)=>{
                this.getExpenseGroupByUid(data);
            });
        },
        inputChange(){
            let reg = /[0-9]{10}/;
            if(reg.test(this.params.search)){
                this.manualInput();
            }
        },
        manualInput(){
            if(this.params.search){
                this.getExpenseGroupByUid(this.params.search, false);
            }else{
                this.$Modal.error({
                    title: '提示',
                    content: '请输入编号'
                });
            }
        },
        getCompanyTotalPrice(company){
            let total = 0;
            company.expense_groups.forEach((expense_group)=>{
                total = math.eval(total + '+' + expense_group.total_price);
            });
            return total.toFixed(2);
        },
        getExpenseGroupByUid(uid, is_continue=true){
            if(this.loading) return;
            this.loading = true;
            Util.ajax.get(Util.api.query_expense_group_by_uid, {
                params: {
                    uid: uid,
                    type: this.type
                }
            }).then((response) => {
                return response.data;
            }).then((data) => {
                this.loading = false;
                if(data.code === 1){
                    this.params.search = '';
                    this.addExpenseGroup(data.expense_group, is_continue);
                }else{
                    this.$Modal.error({
                        title: '提示',
                        content: data.msg
                    });
                }
            }).catch((e) => {
                this.loading = false;
                this.$Modal.error({
                    title: '提示',
                    content: '获取编号: ' + uid + ' 失败, 请重试!'
                });
                console.log(e);
            });
        },
        formatPrice(price){
            price = price ? price : 0;
            return math.eval(price).toFixed(2);
        },
        checkExpenseGroupType(expense_group){
            //return true;
            let payment_type = expense_group.payment_type;
            if(this.type === 'company'){
                if([1,2,3,4].indexOf(payment_type) > -1 && !expense_group.is_outsource){
                    return true;
                }else{
                    this.$Modal.error({title: '提示', content: '此Tab只能导出付款/充值/预支单'});
                    return false;
                }
            }else if(this.type === 'customer'){
                if([0].indexOf(payment_type) > -1){
                    return true;
                }else{
                    this.$Modal.error({title: '提示', content: '此Tab只能导出报销单'});
                    return false;
                }
            }else if(['outsource-bank', 'outsource-alipay'].indexOf(this.type) > -1){
                if([1].indexOf(payment_type) > -1 && expense_group.is_outsource){
                    return true;
                }else{
                    this.$Modal.error({title: '提示', content: '此Tab只能导出兼职外包付款单'});
                    return false;
                }
            }
            this.$Modal.error({title: '提示', content: '未定义导出类型, 请联系开发'});
            return false;
        },
        addExpenseGroup(expense_group, is_continue){
            if(!this.checkExpenseGroupType(expense_group)){
                return;
            }
            let user_flow = expense_group.user_flow;
            if(user_flow){
                if(user_flow.is_finish){
                    this.$Modal.error({
                        title: '提示',
                        content: expense_group.uid + ' 已完成, 不要重复付款!'
                    });
                    return;
                }
                if(!user_flow.pending_finish){
                    this.$Modal.error({
                        title: '提示',
                        content: expense_group.uid + ' 流程审核中, 不能付款!'
                    });
                    return;
                }
            }else{
                // 兼容老状态
                if(expense_group.status === 0){
                    this.$Modal.error({
                        title: '提示',
                        content: expense_group.uid + ' 待审核, 不能付款!'
                    });
                    return;
                }
                if(expense_group.status === 9){
                    this.$Modal.error({
                        title: '提示',
                        content: expense_group.uid + ' 已完成, 不要重复付款!'
                    });
                    return;
                }
            }
            let company = this.companies_hash[expense_group.company_id];
            let expense_groups = company.expense_groups;
            //大额付款不能和小额付款放在一起
            if(expense_groups.length > 0){
                let first_expense_group = expense_groups[0];
                let price_limit = 500000;
                let case1 = first_expense_group.total_price >= price_limit && expense_group.total_price < price_limit;
                let case2 = first_expense_group.total_price < price_limit && expense_group.total_price >= price_limit;
                if(case1 || case2){
                    this.$Modal.error({
                        title: '提示',
                        content: `大额付款(大于等于${price_limit})和小额付款请分别导出`
                    });
                    return;
                }
            }
            //判断是否已存在
            if(!this.isInExpenseGroups(expense_groups, expense_group)){
                expense_groups.push(expense_group);
                if(is_continue){
                    this.$Message.success('扫描成功, 请继续扫描下一单!');
                    this.timer = setTimeout(()=>{
                        this.startQrScaner();
                    }, 3000);
                }
            }else{
                this.$Modal.error({
                    title: '提示',
                    content: expense_group.uid + ' 已存在!'
                });
            }
        },
        removeExpenseGroup(expense_group, index){
            let expense_groups = this.companies_hash[expense_group.company_id].expense_groups;
            expense_groups.splice(index, 1);
        },
        isInExpenseGroups(expense_groups, expense_group){
            let len = expense_groups.length;
            for(let i = 0; i < len; i++){
                if(expense_groups[i].id === expense_group.id){
                    return true;
                }
            }
            return false;
        },
        exportExpenseGroup(company){
            clearTimeout(this.timer);
            let expense_groups_ids = [];
            company.expense_groups.forEach((expense_group)=>{
                expense_groups_ids.push(expense_group.id);
            });
            if(expense_groups_ids.length){
                if(!this.export_params.expense_payment_bank_id){
                    this.$Modal.error({title: '提示', content: '请选择银行'});
                    this.set_bank_config.loading = false;
                    setTimeout(()=>{this.set_bank_config.loading = true;},500)
                    return;
                }
                let params = {
                    company_id: company.id,
                    expense_group_ids: expense_groups_ids,
                    expense_payment_bank_id: this.export_params.expense_payment_bank_id
                };
                console.log(Util.urlEncode(params));
                let url = '';
                if(this.type === 'company'){
                    url = Util.api.export_expense_group_company_to_pay
                }else if(this.type === 'customer'){
                    url = Util.api.export_expense_group_customer_to_pay
                }else if(this.type === 'outsource-bank'){
                    url = Util.api.export_expense_group_outsource_bank_to_pay
                }else if(this.type === 'outsource-alipay'){
                    url = Util.api.export_expense_group_outsource_alipay_to_pay
                }
                window.open(url + '?' + Util.urlEncode(params), '_blank');
            }
            this.set_bank_config.modal = false;
        },
        getBankInfoHtml(expense_payment_bank_id){
            if(expense_payment_bank_id > 0){
                let bank = this.banks_hash[expense_payment_bank_id];
                let html = `<div>${bank.bank} - ${bank.account}</div>`;
                html += `<div>${bank.bank_number} - ${bank.bank_branch}</div>`;
                return html;
            }else{
                return '';
            }
        },
        clearExpenseGroup(company){
            company.expense_groups = [];
        },
        selectBank(bank){
            this.export_params.expense_payment_bank_id = bank.id;
            document.body.click();
        },
        setBank(company){
            clearTimeout(this.timer);
            this.export_params.company = company;
            this.export_params.expense_payment_bank_id = 0;
            this.set_bank_config.modal = true;
        },
        reloadExpenseGroupExport(expense_groups){
            let company_id = expense_groups[0].company_id;
            let target_expense_groups = (this.companies_hash[company_id].expense_groups = []);
            expense_groups.forEach((expense_group)=>{
                target_expense_groups.push(expense_group);
            });
        }
    }
}
